import React from 'react';
import { Box, Alert, AlertTitle, Typography } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const KioskIdError = ({ kioskId, currentUrl }) => {
  // Check if kioskId exists in localStorage as fallback
  let hasKioskId = kioskId;
  if (!hasKioskId && typeof window !== 'undefined') {
    try {
      const stored = localStorage.getItem('kiosk_kioskId');
      if (stored) {
        hasKioskId = parseInt(stored, 10);
      }
    } catch (e) {
      // Ignore localStorage errors
    }
  }
  
  // Only show error if not localhost (development) and kioskId is missing
  if (!hasKioskId && typeof window !== 'undefined') {
    const isLocalhost = window.location.hostname === 'localhost' || 
                       window.location.hostname === '127.0.0.1';
    
    if (!isLocalhost) {
      const serverUrl = window.location.origin;
      const correctUrl = `${serverUrl}?kioskId=1`;
      
      return (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            p: 3
          }}
        >
          <Alert 
            severity="error" 
            icon={<ErrorOutlineIcon />}
            sx={{
              maxWidth: 600,
              width: '100%',
              '& .MuiAlert-message': {
                width: '100%'
              }
            }}
          >
            <AlertTitle sx={{ fontWeight: 'bold', mb: 1 }}>
              Kiosk Location Missing
            </AlertTitle>
            <Typography variant="body1" sx={{ mb: 2 }}>
              The kiosk location identifier is required but was not found in the URL.
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, fontWeight: 'medium' }}>
              Please access the kiosk using the correct URL format:
            </Typography>
            <Box
              component="code"
              sx={{
                display: 'block',
                p: 2,
                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                borderRadius: 1,
                fontFamily: 'monospace',
                fontSize: '0.9rem',
                mb: 2,
                wordBreak: 'break-all'
              }}
            >
              {correctUrl}
            </Box>
            <Typography variant="body2" color="text.secondary">
              Replace <strong>kioskId=1</strong> with the appropriate kiosk number (1, 2, 3, etc.)
            </Typography>
          </Alert>
        </Box>
      );
    }
  }
  
  return null;
};

export default KioskIdError;

